var textDecorations = new Set(["underline", "none", "line-through"]);
export default (function (_a) {
    var textDecoration = _a.textDecoration;
    return textDecorations.has(textDecoration) && "text-decoration: ".concat(textDecoration, ";");
});
